import { memo } from 'react';
import { Claim } from '@scale/shared/types/queue';
import { PayRateType } from '@scale/shared/defaults';

import ClaimModal from './ClaimModal';

type OvertimeLimitExceededModalProps = {
  onStayOnTask: () => void;
  claim?: Claim;
  payRateType?: PayRateType;
};

function OvertimeLimitExceededModal({
  claim,
  payRateType,
  onStayOnTask,
}: OvertimeLimitExceededModalProps) {
  if (!claim) {
    return null;
  }

  // Only show for hourly pay types
  if (![PayRateType.Hourly, PayRateType.HourlyTraining].includes(payRateType as PayRateType)) {
    return null;
  }

  return (
    <ClaimModal
      onConfirmButtonClick={onStayOnTask}
      confirmButtonText="Continue task"
      title="Reached time limit"
      subtitle={
        <div className="text-sm m-5">
          Please submit the task to receive payment. You may continue this task, but you will not be
          paid for the additional time.
        </div>
      }
    />
  );
}

export default memo(OvertimeLimitExceededModal);
